var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61133 10.1393H11.8335V2.47266H2.80985C2.14793 2.47266 1.61133 3.02376 1.61133 3.70364V10.1393Z",
    fill: "#FFCB4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18908 2.92513L8.85807 3.63579C8.63019 4.12501 8.13336 4.43863 7.58633 4.43863H1.54013C0.873698 4.43866 0.333496 4.97007 0.333496 5.62558V13.4238C0.333496 14.0794 0.873728 14.6108 1.54016 14.6108H14.4602C15.1266 14.6108 15.6668 14.0794 15.6668 13.4238V3.01996C15.6668 2.36441 15.1266 1.83301 14.4602 1.83301H10.9191C10.1749 1.83298 9.49904 2.25969 9.18908 2.92513Z",
    fill: "#FFDD8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.226afa04a5eb5144064b500765f094a6.svg";
export { ForwardRef as ReactComponent };